import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { CONTACT } from "@/lib/data";
import { useI18n } from "@/context/LanguageContext";

export const WhatsappFloat = () => {
  const { t } = useI18n();
  return (
  <motion.a
    href={`https://wa.me/${CONTACT.whatsapp}?text=Hi%20Nidhi%20Fabrication%2C%20I%27d%20like%20a%20quote.`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 200, damping: 15 }}
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 h-14 px-4 sm:pr-5 bg-[#25D366] text-white font-mono2 text-sm font-700 uppercase tracking-wider border-2 border-charcoal hard-shadow-sm hover:translate-x-[2px] hover:translate-y-[2px] transition-transform"
  >
    <MessageCircle size={22} />
    <span className="hidden sm:inline">{t.cta.whatsappUs}</span>
  </motion.a>
  );
};
